import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Pagination from '@mui/material/Pagination'

import '../../css/common/KeyList.css'

const TFooter = ({
  show,
  showingText,
  pageNum,
  totalPages,
  handlePageChange,
  allowLoadMore,
  onLoadMoreClick,
}) => {
  const { t } = useTranslation()

  return (
    show && (
      <div className="d-flex align-items-center">
        <div className="mr-auto responsive-font">{showingText}</div>
        <Pagination
          className="responsive-pagination"
          page={pageNum}
          count={totalPages}
          shape="rounded"
          onChange={handlePageChange}
        />
        {allowLoadMore && (
          <button className="link responsive-button" onClick={onLoadMoreClick}>
            {t('load_more')}
          </button>
        )}
      </div>
    )
  )
}

TFooter.propTypes = {
  show: PropTypes.bool.isRequired,
  showingText: PropTypes.node.isRequired,
  pageNum: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  allowLoadMore: PropTypes.bool.isRequired,
  onLoadMoreClick: PropTypes.func.isRequired,
}

export default TFooter
